import ShipmentName from "./ShipmentName";
import ShipmentLink from "./ShipmentLink";

import CuttingName from "../../../../timber/components/cutting/CuttingDetail/CuttingName";
import CuttingLink from "../../../../timber/components/cutting/CuttingDetail/CuttingLink";

import TimberStorageName from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageName";
import TimberStorageLink from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageLink";

import ContractorUserName from "../../../../timber/components/contractorUser/ContractorUserDetail/ContractorUserName";
import ContractorUserLink from "../../../../timber/components/contractorUser/ContractorUserDetail/ContractorUserLink";

import LocationName from "../../../../location/components/location/LocationDetail/LocationName";
import LocationLink from "../../../../location/components/location/LocationDetail/LocationLink";

import BuyerName from "../../../../timber/components/buyer/BuyerDetail/BuyerName";
import BuyerLink from "../../../../timber/components/buyer/BuyerDetail/BuyerLink";

import RoadCarrierName from "../../../../timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierName";
import RoadCarrierLink from "../../../../timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ShipmentDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="Shipment-detail-title"
                    >
                        { label || t`Shipment` }: <ShipmentName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="Shipment-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="Shipment-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } data-testid="key-label" sx={{ textAlign: "left" }}><Trans>Key</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="key-value" sx={{ textAlign: "left" }}>{ data.key || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="reportKey-label" sx={{ textAlign: "left" }}><Trans>Report Key</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="reportKey-value" sx={{ textAlign: "left" }}>{ data.reportKey || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="cuttingId-label" sx={{ textAlign: "left" }}><Trans>Cutting</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="cuttingId-value" sx={{ textAlign: "left" }}>{ data.cuttingId ? (<CuttingLink id={ data.cuttingId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="storageId-label" sx={{ textAlign: "left" }}><Trans>Timber Storage</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="storageId-value" sx={{ textAlign: "left" }}>{ data.storageId ? (<TimberStorageLink id={ data.storageId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentAt-label" sx={{ textAlign: "left" }}><Trans>Shipment At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.shipmentAt) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="shippingContractorUserId-label" sx={{ textAlign: "left" }}><Trans>Contractor User</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shippingContractorUserId-value" sx={{ textAlign: "left" }}>{ data.shippingContractorUserId ? (<ContractorUserLink id={ data.shippingContractorUserId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="sourceLocationId-label" sx={{ textAlign: "left" }}><Trans>Location</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="sourceLocationId-value" sx={{ textAlign: "left" }}>{ data.sourceLocationId ? (<LocationLink id={ data.sourceLocationId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="sourceParcel-label" sx={{ textAlign: "left" }}><Trans>Source Parcel</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="sourceParcel-value" sx={{ textAlign: "left" }}>{ data.sourceParcel || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="buyerId-label" sx={{ textAlign: "left" }}><Trans>Buyer</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="buyerId-value" sx={{ textAlign: "left" }}>{ data.buyerId ? (<BuyerLink id={ data.buyerId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="targetAddress-label" sx={{ textAlign: "left" }}><Trans>Target Address</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="targetAddress-value" sx={{ textAlign: "left" }}>{ data.targetAddress || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="targetCity-label" sx={{ textAlign: "left" }}><Trans>Target City</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="targetCity-value" sx={{ textAlign: "left" }}>{ data.targetCity || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="targetCountry-label" sx={{ textAlign: "left" }}><Trans>Target Country</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="targetCountry-value" sx={{ textAlign: "left" }}>{ data.targetCountry || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="state-label" sx={{ textAlign: "left" }}><Trans>State</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="state-value" sx={{ textAlign: "left" }}>{ toStringShipmentState(data.state) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentType-label" sx={{ textAlign: "left" }}><Trans>Shipment Type</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentType-value" sx={{ textAlign: "left" }}>{ toStringShipmentType(data.shipmentType) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="roadCarrierId-label" sx={{ textAlign: "left" }}><Trans>Road Carrier</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="roadCarrierId-value" sx={{ textAlign: "left" }}>{ data.roadCarrierId ? (<RoadCarrierLink id={ data.roadCarrierId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="truckRegistrationNumber-label" sx={{ textAlign: "left" }}><Trans>Truck Registration Number</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="truckRegistrationNumber-value" sx={{ textAlign: "left" }}>{ data.truckRegistrationNumber || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="truckerName-label" sx={{ textAlign: "left" }}><Trans>Trucker Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="truckerName-value" sx={{ textAlign: "left" }}>{ data.truckerName || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="workOrder-label" sx={{ textAlign: "left" }}><Trans>Work Order</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="workOrder-value" sx={{ textAlign: "left" }}>{ data.workOrder || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentOrder-label" sx={{ textAlign: "left" }}><Trans>Shipment Order</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentOrder-value" sx={{ textAlign: "left" }}>{ data.shipmentOrder || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="forPersonalUse-label" sx={{ textAlign: "left" }}><Trans>For Personal Use</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="forPersonalUse-value" sx={{ textAlign: "left" }}>{ data.forPersonalUse ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="description-label" sx={{ textAlign: "left" }}><Trans>Description</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="description-value" sx={{ textAlign: "left" }}>{ data.description || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default ShipmentDetail;
